import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-gradient-to-b from-teal-50 to-cream-50 py-3 sm:py-20" data-id="element-132">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-134">
          <p className="text-[10px] leading-tight sm:text-base text-teal-700 font-semibold mb-2 sm:mb-4 uppercase tracking-wide" data-id="element-135">
            PARA LA PROFESIONAL QUE SON LAS 12 DE LA NOCHE Y TODAVÍA ESTÁ
            SENTADA PREPARANDO EL MATERIAL PARA EL PACIENTE DE MAÑANA…
          </p>

          <h1 className="text-2xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-1 sm:mb-4 leading-tight" data-id="element-136">
            Kit Clínico Cognitivo™
          </h1>

          <p className="text-sm sm:text-2xl text-gray-700 mb-2 sm:mb-6 font-medium leading-snug" data-id="element-137">
            El sistema completo de intervención cognitiva para profesionales de
            la salud
          </p>

          <p className="hidden sm:block text-lg text-gray-600 mb-8 italic" data-id="element-138">
            Mereces llegar a cada sesión con la tranquilidad de saber que ya
            tenés todo resuelto. Tu tiempo, tu energía y tu vocación valen
            demasiado para seguir armando actividades desde cero a las 12 de la
            noche.
          </p>
          <p className="sm:hidden text-[11px] text-gray-600 mb-2 italic leading-snug px-2" data-id="element-139">
            Mereces llegar a cada sesión con todo resuelto. Tu tiempo y tu
            vocación valen demasiado.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-3 sm:mb-10" data-id="element-140">
            <a href="#checkout" className="block" data-id="element-141">
              <img src="https://cdn.magicpatterns.com/uploads/rbgm8zn7Cs1ZWU8uJJAv8D/ChatGPT_Image_7_may_2026__09_10_20_p.m.-removebg-preview.png" alt="Kit Clínico Cognitivo" className="w-full max-w-[180px] sm:max-w-2xl mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" data-id="element-142" />
              {/* REPLACE THIS IMAGE WITH YOUR ACTUAL PRODUCT MOCKUP */}
            </a>
          </motion.div>

          <div className="bg-white rounded-lg p-3 sm:p-6 shadow-md mb-3 sm:mb-8 text-left" data-id="element-143">
            <p className="text-[10px] sm:text-sm font-bold text-teal-700 mb-2 sm:mb-4 uppercase text-center leading-tight" data-id="element-144">
              NUEVO — 4 Módulos Clínicos + 4 Herramientas de Gestión + 2 Súper
              Bonos · Descarga inmediata
            </p>

            <ul className="space-y-1 sm:space-y-3" data-id="element-145">
              {['300 fichas técnicas de estimulación cognitiva listas para imprimir y usar', 'Cobertura completa de 12 a 90 años en un solo sistema', 'Protocolos diferenciados por nivel de deterioro cognitivo', 'Herramientas de gestión clínica: screening, planificador y cartelería', 'Guía de alertas para saber cuándo derivar al neurólogo', 'Diseñado para psicólogos, terapeutas ocupacionales, fonoaudiólogos y psicopedagogos'].map((item, index) => <li key={index} className="flex items-start gap-2 sm:gap-3" data-id="element-146">
                  <Check className="w-3 h-3 sm:w-5 sm:h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-147" />
                  <span className="text-[11px] sm:text-base text-gray-700 leading-snug" data-id="element-148">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="mb-2 sm:mb-6" data-id="element-149">
            <p className="text-base sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-150">
              Pago único de $19.990 ARS · Acceso inmediato
            </p>
          </div>

          <div className="[&_a]:py-3 [&_a]:text-sm sm:[&_a]:py-5 sm:[&_a]:text-lg" data-id="element-151">
            <CTAButton data-id="element-152">ACCEDER AL KIT CLÍNICO COGNITIVO™ AHORA</CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}